module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- <div id=\'cmdmenu\'>\n	Users\n	<div id=\'create\' class=\'cmd button\'>Add User</div>\n</div> -->\n';
}
return __p;
};
